import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

export const useWallet = () => {
  const [usdValue, setUsdValue] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      setUsdValue(0);
      setLoading(false);
      return;
    }

    const fetchWalletValue = async () => {
      try {
        const { data, error } = await supabase
          .from('user_wallets')
          .select('usd_value')
          .eq('user_id', user.id)
          .single();

        if (error) {
          console.error('Error fetching wallet value:', error);
        } else if (data) {
          setUsdValue(Number(data.usd_value));
        }
      } catch (error) {
        console.error('Error fetching wallet value:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchWalletValue();

    // Set up real-time subscription for wallet updates
    const subscription = supabase
      .channel('user_wallet_updates')
      .on('postgres_changes', 
        { 
          event: '*', 
          schema: 'public', 
          table: 'user_wallets',
          filter: `user_id=eq.${user.id}`
        }, 
        (payload) => {
          if (payload.new && typeof (payload.new as any).usd_value !== 'undefined') {
            setUsdValue(Number((payload.new as any).usd_value));
          }
        }
      )
      .subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, [user]);

  return {
    usdValue,
    loading,
    formattedValue: `$${usdValue.toFixed(2)} USD`
  };
};